<template>
    <!-- Page Content -->
    <b-overlay :show="isLoadingImages" rounded="lg">
    <div class="container">

        <div class="row text-center text-lg-left" v-if="srcs.length > 0">
                <div class="col-lg-3 col-md-4 col-6" v-for="(src, index) in srcs" :key="index" >
                    <b-card
                        :img-src="src + '?thumb=1'"
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;"
                        class="mb-2"
                    >
                        <b-card-text>
                        
                        </b-card-text>

                        <b-button type="button" @click.stop.prevent="selectImage(src)" variant="primary">Selecionar</b-button>
                        &nbsp;&nbsp;
                        <b-button type="button" @click.stop.prevent="deleteImage(src)" variant="danger">Deletar</b-button>
                    </b-card>
                </div>
        </div>
        
        <div v-if="!isLoadingImages && srcs.length === 0">
            Sem imagens cadastradas
        </div>

    </div>
    </b-overlay>
    <!-- /.container -->
</template>

<script>
import { mapGetters } from 'vuex';
import { getProfileAction, fixImagePath, deleteImage } from './../configs/services';
import Bus from './../configs/bus';
import Swal from 'sweetalert2';
import Lockr from "lockr";

export default {
    name: 'Gallery',
    data(){
        return {
            isLoadingImages: false,
            srcs: []
        }
    },
    mounted(){
        const vm = this;
        vm.isLoadingImages = true;
        
        getProfileAction()
        .then(data => data.images)
        .then(images => {
            //
            images.forEach(img => {
                vm.srcs.push(fixImagePath(img.id))
            })

            vm.isLoadingImages = false;
        })
        .catch(err => {
            vm.isLoadingImages = false;
        })
    },
    methods: {
        selectImage(src){
            Bus.$emit('image', src);
        },
        deleteImage(src){
            let lastURLSegment = src.substr(src.lastIndexOf('/') + 1);
            
            console.log(lastURLSegment);
            
            Swal.fire({
                title: 'Tem certeza?',
                text: "Deseja deletar essa imagem?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    deleteImage(lastURLSegment)
                    .then(data => {
                        
                        Lockr.remove('image');

                        Swal.fire("Sucesso!", "Imagem deletada com sucesso", "success")
                        .then(() => window.location.reload());
                    })
                    .catch(this.errorHandler);                    
                }
            });

        }
    }
}
</script>